// extracted by mini-css-extract-plugin
export default {"backgroundImage":"KC","content":"LC","rtbLeft":"MC","rtbRight":"NC","rtbLeftMobile":"OC","imageContainer":"PC","rtbBox":"QC","line":"RC","rtbDesktop":"SC"};
    if(module.hot) {
      // 1713996747422
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  